import { __extends } from "tslib";
import { Subscriber } from '../Subscriber';
import { lift } from '../util/lift';
export function refCount() {
    return function refCountOperatorFunction(source) {
        return lift(source, new RefCountOperator());
    };
}
var RefCountOperator = (function () {
    function RefCountOperator() {
    }
    RefCountOperator.prototype.call = function (subscriber, connectable) {
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = connectable.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = (function (_super) {
    __extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        _this.connection = null;
        return _this;
    }
    RefCountSubscriber.prototype.unsubscribe = function () {
        if (!this.closed) {
            var connectable = this.connectable;
            if (!connectable) {
                this.connection = null;
                return;
            }
            this.connectable = null;
            var refCount_1 = connectable._refCount;
            if (refCount_1 <= 0) {
                this.connection = null;
                return;
            }
            connectable._refCount = refCount_1 - 1;
            if (refCount_1 > 1) {
                this.connection = null;
                return;
            }
            var connection = this.connection;
            var sharedConnection = connectable._connection;
            this.connection = null;
            if (sharedConnection && (!connection || sharedConnection === connection)) {
                sharedConnection.unsubscribe();
            }
            _super.prototype.unsubscribe.call(this);
        }
    };
    return RefCountSubscriber;
}(Subscriber));
//# sourceMappingURL=refCount.js.map